import { action } from 'typesafe-actions';
import { RecentHistory } from '../../model/recentHistory';
import { RecentHistoryTypes } from './types';

export const addInRecents = (recent: RecentHistory) => action(RecentHistoryTypes.ADD_IN_RECENTS, recent);
export const setRecents = () => action(RecentHistoryTypes.SET_RECENTS);
